const initialState = {
    templates: [],
    isCreatingTemplate: false,
    isReadingTemplates: false
}

export default initialState;
